<template>
  <div class="bg-white">
    <div class="md:flex md:flex-col">
      <div class="h-48 flex flex-col items-center bg-gray-900">
        
        <div class="z-60 mt-4 content-rotate">        
            <h1 class="text-white font-bold text-2xl">Unleash</h1>
            <h1 class="text-white text-xl -mt-3">Your inner</h1>
            <h2 class="text-blue-300 font-bold text-2xl -mt-2">Memelord <span class="text-white font-normal">or</span> Animation Ninja</h2>
        </div>
        
            
        
          <div class="flex items-center justify-around overflow-hidden pb-4 z-10 -mt-10">
              <img class="-mb-32 w-full md:w-32 content-rotate -ml-6 sm:ml-6" src='/img/PBC_Meme.svg' />   
              <div class="flex flex-col items-center mx-10 mt-12 md:mt-10">
                <div class="text-center text-md bg-white w-16 h-16 rounded-full font-bold text-gray-900">
                  <help-circle :size='64' />
                </div>
              </div>

              <img class="w-full md:w-32 content-rotate " src='/img/PBC_Ninja.svg'/>
          </div>
      </div>
      <div class="mx-2 mt-4 md:w-2/3 md:self-center">
        <h3 class="mt-4 ml-4 tracking-wider text-3xl text-gray-700">How To Get Help</h3>
        <!--
        <h1 class="tracking-tight text-2xl text-black">Talk to us at any time.</h1>
        <div class="text-xl text-gray-600">
          Have questions about making memes, making games or Playboxcade? Just tap the
          <span class="font-bold text-black">"Get Help Now"</span>
          button and we can help you right now.
        </div>
        -->
      </div>
    </div>

    <pbc-cta-help></pbc-cta-help>
  </div>
</template>
<script>
import HelpCircle from '@icons/HelpCircle.vue';
import PbcCtaHelp from '@ui/atoms/PbcCtaHelp.vue';
export default {
  components: {
    PbcCtaHelp,
    HelpCircle
  },
  mounted() {
    this.$ana.track({
      eventCategory: 'ui',
      eventAction: 'showHelp'
    });
  },
}
</script>
<style scoped>
.content-rotate {
transform: rotate(-7deg);
overflow: hidden;
}
</style>
